import texts from "./global-error-texts.json";

type Language = keyof typeof texts;

/** The language of the failed page, read from the first segment of its address; English when it is not one we have texts for. */
export function globalErrorLanguage(pathname: string): Language {
  const first = pathname.split("/")[1];
  return Object.hasOwn(texts, first) ? (first as Language) : "en";
}
